var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.461,
    height: 43.461,
    viewBox: "0 0 43.461 43.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M335.479,309.868l-2.536,7.031a52.466,52.466,0,0,1,0,26.916l2.536,7.031a21.732,21.732,0,0,0,0-40.977Z",
    transform: "translate(-306.503 -308.627)",
    fill: "#db001b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(21.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M330.766,315.657v-7.031a21.691,21.691,0,0,0-7.245-1.242C326.872,307.384,322.226,318.74,330.766,315.657Z",
    transform: "translate(-323.461 -307.384)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M323.461,386.007a21.69,21.69,0,0,0,7.245-1.242v-7.031C322.252,376.891,323.461,386.007,323.461,386.007Z",
    transform: "translate(-323.401 -342.546)",
    fill: "#ddd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M280.042,330.329a21.735,21.735,0,0,0,14.571,20.518V309.812A21.734,21.734,0,0,0,280.042,330.329Z",
    transform: "translate(-280.042 -308.599)",
    fill: "#174795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M338.016,323.936v26.916A52.452,52.452,0,0,0,338.016,323.936Z",
    transform: "translate(-309.041 -315.663)",
    fill: "#e2373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M323.6,342.573V315.657c-1.479-4.884-3.894-8.273-7.245-8.273a21.683,21.683,0,0,0-7.16,1.214v41.034a21.685,21.685,0,0,0,7.16,1.213C319.706,350.845,322.12,347.456,323.6,342.573Z",
    transform: "translate(-294.624 -307.384)",
    fill: "#f0f1f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.c7272161adade4b272787ff5079fdcc2.svg";
export { ForwardRef as ReactComponent };